export default resourceType => fieldName => {
  const disabledFields = {
    Normal: ['Key', 'Slug'],
    SubResource: [
      'Key',
      'Slug',
      'Capacity',
      'TeamSize',
      'TimeslotMinutes',
      'IgnoreTimeslotDuration',
      'OneTimeLeadIn',
      'PermanentLeadIn',
      'ResetTime',
      'AllowOrderChanges',
      'OfflineProductKey',
    ],
    ResourceGroup: ['Key', 'Slug', 'ShowOnScheduler', 'Priority'],
  }
  return disabledFields[resourceType].includes(fieldName)
}
